import React from 'react';
import {ScrollView, StyleSheet, useWindowDimensions, View} from 'react-native';
import {ThemeProvider} from '@rneui/themed';

import Text from '../../../components/ui-controls/Text';
import {space} from '../../../design-system/tokens';
import {AppRoute} from '../../../models/AppRoute';
import theme from '../../../style/theme';
import rewardsTheme from '../../../theme/rewardsTheme';

import NotFoundTicketIcon from './NotFoundTicketIcon';
import {PanelButton} from './OfferPanelLayout';

type OfferNotFoundProps = {
  navigation: {
    navigate: (route: string) => void;
  };
  isConfirmedNonMember: boolean;
};

const OfferNotFound = ({navigation, isConfirmedNonMember}: OfferNotFoundProps) => {
  const {width} = useWindowDimensions();
  const isSmallScreen = width < 380;

  return (
    <ThemeProvider theme={rewardsTheme}>
      <ScrollView
        contentContainerStyle={styles.scrollContainer}
        showsVerticalScrollIndicator={false}>
        <View style={styles.container}>
          <NotFoundTicketIcon
            width={isSmallScreen ? 120 : 144}
            height={isSmallScreen ? 80 : 96}
            color={theme.colour.general.secondary}
          />

          <Text style={[styles.headline, isSmallScreen && styles.headlineSmall]}>
            THIS EXCLUSIVE OFFER HAS FINISHED
          </Text>

          <Text style={[styles.description, isSmallScreen && styles.descriptionSmall]}>
            Looks like this offer has ended or is no longer available.{'\n'}
            Don&apos;t worry - we&apos;ve got plenty of other great deals for you.
          </Text>

          <View style={styles.buttonContainer}>
            <PanelButton
              title="View current exclusive offers"
              // DIS-1917: the offer list sends a viewer without rewards to Home, and an
              // unknown membership status must not be offered a join.
              onPress={() =>
                navigation.navigate(
                  isConfirmedNonMember ? AppRoute.REWARDS : AppRoute.EXCLUSIVE_OFFER_LIST,
                )
              }
            />
            <PanelButton
              title="See all promotions"
              onPress={() => navigation.navigate(AppRoute.PROMOTIONS_CURRENT)}
              variant="outlined"
            />
          </View>

          <View style={styles.linkContainer}>
            <PanelButton
              title="Go to Home"
              onPress={() => navigation.navigate(AppRoute.HOME)}
              variant="text"
            />
          </View>
        </View>
      </ScrollView>
    </ThemeProvider>
  );
};

export default OfferNotFound;

const styles = StyleSheet.create({
  scrollContainer: {
    flexGrow: 1,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    paddingVertical: 32,
    minHeight: 400,
  },
  headline: {
    fontSize: 18,
    fontWeight: 'bold',
    color: theme.colour.text.heading.primary,
    textAlign: 'center',
    marginTop: 24,
    marginBottom: 16,
  },
  headlineSmall: {
    fontSize: 16,
  },
  description: {
    fontSize: 14,
    color: theme.colour.text.content.primary,
    textAlign: 'center',
    lineHeight: 22,
    marginBottom: 32,
    paddingHorizontal: 8,
  },
  descriptionSmall: {
    fontSize: 13,
    lineHeight: 20,
  },
  buttonContainer: {
    width: '100%',
    maxWidth: 300,
    gap: space.s12,
  },
  linkContainer: {
    width: '100%',
    maxWidth: 300,
    marginTop: space.s12,
  },
});
